import { createAction } from 'redux-actions'

const CHANGE_MOUSE_CURSOR = 'CHANGE_MOUSE_CURSOR'
const CAPTURING_STATUS_CHANGED = 'CAPTURING_STATUS_CHANGED'
const SEND_INPUT_STATUS_CHANGED = 'SEND_INPUT_STATUS_CHANGED'
const HIDE_SEND_INPUT_NOTIFICATION = 'HIDE_SEND_INPUT_NOTIFICATION'
const VIDEO_STREAM_UNMUTED = 'VIDEO_STREAM_UNMUTED'
const VIDEO_STREAM_MUTED = 'VIDEO_STREAM_MUTED'
const SCREEN_SHARING = 'SCREEN_SHARING'

export const changeMouseCursor = createAction(CHANGE_MOUSE_CURSOR)
export const notifyCapturingStatusChanged = createAction(CAPTURING_STATUS_CHANGED)
export const notifySendInputStatusChanged = createAction(SEND_INPUT_STATUS_CHANGED)
export const hideSendInputNotification = createAction(HIDE_SEND_INPUT_NOTIFICATION)
export const videoStreamUnmuted = createAction(VIDEO_STREAM_UNMUTED)
export const videoStreamMuted = createAction(VIDEO_STREAM_MUTED)
export const screenSharing = createAction(SCREEN_SHARING)
